import _ from "lodash";
import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import AssessmentDetails from "./AssessmentDetails";
const validateFunction = ({ path, pathName }) => {
  switch (pathName) {
    case ":assessmentId":
      return !isNaN(path);
    case ":mode":
      return _.includes(["edit", "create", "view"], path);
  }
};
export default store => {
  return {
    path: "assessment/:assessmentId/:mode",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "unit-planner" */ "./AssessmentDetails"),
          import(
            /* webpackChunkName: "unit-planner" */ "Assessments/modules/AssessmentModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "OrganizationResources/modules/OrganizationResourcesModule"
          ),
          import(
            /* webpackChunkName: "unit-planner" */ "UnitPlans/modules/UnitPlanModule"
          ),
        ]).then(
          ([
            importedModule0,
            importedModule1,
            importedModule2,
            importedModule3,
          ]) => {
            const component = importedModule0.default;
            const injectedModule = importedModule1;
            const OrganizationResourcesReducer = importedModule2.default;
            const reducer = importedModule3.default;
            injectReducer(store, {
              key: injectedModule.NAME,
              reducer: injectedModule.default,
            });
            injectReducer(store, {
              key: "unitPlans",
              reducer,
            });
            injectReducer(store, {
              key: "organizationResource",
              reducer: OrganizationResourcesReducer,
            });
            return withDynamicUrlValidation({
              component,
              urlValidationType: "customValidation",
              customUrlValidationFunction: validateFunction,
            });
          }
        )
      // .catch(err => {
      //   throw err;
      // })
    ),
  };
};
export { AssessmentDetails as AssessmentDetailsComponent };
